export default __webpack_public_path__ + "static/media/finalTubeligh.1dfdf74b.png";